module.exports = __webpack_public_path__ + "img/3.d4570a94.png";